import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[selectFooterContent]',
  standalone: false,
})
export class SelectFooterContent {
  readonly tr = inject<TemplateRef<any>>(TemplateRef);
}
